module.exports = __webpack_public_path__ + "img/incomingsms.9e302603.svg";